export const BASE_URL = process.env.REACT_APP_API_END_POINT
export const REPORT_URL = process.env.REACT_APP_API_END_POINT_REPORT
export const KEY_MIXPANEL = '3bd3ccfbb51140b5169a07a95dab4e8c'

export const PATH = {
  HOME: '/',
  ROADMAP_SUMMARY: '/roadmap-summary',
  LESSON: '/lesson',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGET_PASSWORD: '/forget-password',
  LEARN: '/learn',
  LESSON_LEARN: '/learn/lesson',
  CONVERSATION: '/learn/conversation',
  LEARN_NOTEBOOK: '/learn/notebook',
  LEARN_REVISE: '/learn/revise',
  LEARN_REVISE_ROOM: '/learn/revise-room',
  LEARN_REVISE_ROOM_COMPLETE: '/learn/revise-room-complete',
  LEARN_VOCABULARY: '/learn/vocabulary',
  LEARN_VOCABULARY_OVERVIEW: '/learn/vocabulary-overview',
  LEARN_VOCABULARY_RESULT: '/learn/vocabulary-result',
  LEARN_REVISE_SENTENCE: '/learn/revise-sentence',
  LEARN_REVISE_SENTENCE_OVERVIEW: '/learn/revise-sentence-overview',
  LEARN_REVISE_SENTENCE_RESULT: '/learn/revise-sentence-result',
  LEARN_FAST_TRACK: '/learn/fast-track',
  LEARN_PART_TWO: '/learn/part-two',
  LEARN_PART_THREE: '/learn/part-three',
  EXAM: '/exam',
  EXAM_ROOM: '/exam/exam-room',
  EXAM_RESULT: '/exam/result-board',
  EXAM_HISTORY: '/exam/history',
  GYM: '/gym',
  GYM_PRONOUNCE: '/gym/pronounce',
  GYM_PAIR: '/gym/pair',
  GYM_PRACTICE: '/gym/practice',
  GYM_RESULT: '/gym/result',
  GYM_VOCABULARY: '/gym/vocabulary',
  HEALTH: '/health',
  PARAPHRASE_ROOM: '/paraphrase-room',
}

export const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  USER_NAME: 'USER_NAME',
  USER_ID: 'USER_ID',
  USER_PHONE: 'USER_PHONE',
  USER_EMAIL: 'USER_EMAIL',
  IS_SHOW_START_MIC_TOOL_TIP: 'IS_SHOW_START_MIC_TOOL_TIP',
  IS_SHOW_TIP_TRANSLATE: 'IS_SHOW_TIP_TRANSLATE',
  IS_SHOW_MESSAGE_NEXT: 'IS_SHOW_MESSAGE_NEXT',
  IS_SHOW_TOUR_LEARN: 'IS_SHOW_TOUR_LEARN',
  IS_SHOW_END_MIC_TOOL_TIP: 'IS_SHOW_END_MIC_TOOL_TIP',
  REFERRAL_USER_ID: 'REFERRAL_USER_ID',
}

export const SESSION_STORAGE = {
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  IS_CHECK_DEVICE: 'is_check_device',
}

export const SCREEN_TRACKING = {
  ONBOARDING: 'Onboarding',
  ONBOARDING_FULL: 'onboarding/roadmap/screen_view',
  LOGIN_PAGE: 'login/screen_view',
  LOGIN_PAGE_SUCCESS: 'login/sign_up_successful',
  REGISTER_PAGE: 'register/create_account',
  OTP_PAGE: 'register/otp',
  REGISTER_SUCCESS: 'register/correct_otp',
  ROADMAP_PAGE: 'map/screen_view',
  ROADMAP_LESSON_SUMMARY: 'map/lesson_summary_screen',
  ROADMAP_WEEK_SUMMARY: 'map/week_summary_screen',
  SALE_SCREEN_VIEW: 'sale/screen_view',
}

export const EVENT_NAME = {
  CLICK_TOPIC: 'topic/screen_view',
  CLICK_LESSON: 'topic/click_lesson',
  CLICK_END: 'click_end',
  MAP_CONTINUE_BUTTON_CLICK: 'map/continue_button_click',
  MAP_REVIEW_BUTTON_CLICK: 'map/review/screen_view',
  MAP_DAILY_REVIEW_START: 'map/daily_review_start',
  MAP_LESSON_START: 'map/lesson_start',
  MAP_WEEK_EXPAND: 'map/week_expand',
  MAP_LESSON_SUMMARY_CONTINUE_LEARN: 'map/lesson_summary_screen/continue_learn',
  MAP_LESSON_SUMMARY_BACK_MAP: 'map/lesson_summary_screen/back_map',
  MAP_WEEK_SUMMARY_CONTINUE_LEARN: 'map/week_summary_screen/continue_learn',
  MAP_WEEK_SUMMARY_BACK_MAP: 'map/week_summary_screen/back_map',
  SALE_PLACE_ORDER: 'sale/place_order',
  SALE_CONTINUE_TRIAL: 'sale/continue_trial',
  SALE_CLOSE_SALE: 'sale/close_sale',
  SALE_ACTIVE_BUYER: 'sale/active_buyer',
}

export const EXAM_SCREEN_TRACKING = {
  GUILD_EXAM: 'practice/guide/screen_view',
  QUESTION_LIST_EXAM: 'practice/question_list/screen_view',
  ANSWER_QUESTION_EXAM: 'practice/answer_a_question/screen_view',
  FEED_BACK_EXAM: 'practice/feedback_screen/screen_view',
}

export const EVENT_ACTION = {
  CLICK: 'Click',
  CLICK_FINISH: 'click_finish',
}

export const STATUS_CODE = {
  SUCCESS: 0,
  RATE_LIMIT: 1,
  TOKEN_EXPIRE: 2,
  TOKEN_FAIL: 3,
  OTP_FAIL: 4,
  NOT_ACCESS: 5,
}

export const AUTH_ACTION = {
  FORGET_PASSWORD: 'FORGET_PASSWORD',
  SIGN_UP: 'SIGN_UP',
}

export const TYPE_SCORE = {
  FLUENCY_AND_COHERENCE: 'FLUENCY_AND_COHERENCE',
  GRAMMAR: 'GRAMMAR',
  VOCABULARY: 'VOCABULARY',
  PRONUNCIATION: 'PRONUNCIATION',
}

export const FEATURE_NAME = {
  IPA: 'IPA',
  VOCABULARY: 'VOCABULARY',
  PRACTICE_PHRASE: 'PRACTICE_PHRASE',
  PRACTICE_SENTENCE: 'PRACTICE_SENTENCE',
  LESSON_PART_ONE: 'LESSON_PART_ONE',
  LESSON_PART_TWO: 'LESSON_PART_TWO',
  DEMO_TEST_PART_ONE: 'DEMO_TEST_PART_ONE',
  DEMO_TEST_PART_TWO: 'DEMO_TEST_PART_TWO',
  FAST_TRACK: 'FAST_TRACK',
}

export const FEATURE_REPORT_ERROR = {
  IPA_COURSE: 'IPA_COURSE',
  VOCABULARY_STUDY: 'VOCABULARY_STUDY',
  PRACTICE_PHRASE: 'PRACTICE_PHRASE',
  PRACTICE_SENTENCE: 'PRACTICE_SENTENCE',
  LESSON_PART_1: 'LESSON_PART_1',
  LESSON_PART_2: 'LESSON_PART_2',
  DEMO_TEST_PART_1: 'DEMO_TEST_PART_1',
  DEMO_TEST_PART_2: 'DEMO_TEST_PART_2',
  FAST_TRACK: 'FAST_TRACK',
}

export const SCREEN_REPORT_ERROR = {
  HOC_PHAT_AM: 'HOC_PHAT_AM',
  CAP_TU: 'CAP_TU',
  KIEM_TRA: 'KIEM_TRA',
  LUYEN_TAP: 'LUYEN_TAP',
  XEM_TINH_HUONG: 'XEM_TINH_HUONG',
  CHON_HINH_ANH: 'CHON_HINH_ANH',
  PHAT_AM: 'PHAT_AM',
  TRAC_NGHIEM: 'TRAC_NGHIEM',
  ON_CO_BAN_TRAC_NGHIEM: 'ON_CO_BAN_TRAC_NGHIEM',
  ON_CO_BAN_GHI_AM: 'ON_CO_BAN_GHI_AM',
  NGHE_TRA_LOI_DIEN_TU: 'NGHE_TRA_LOI_DIEN_TU',
  NGHE_HIEU: 'NGHE_HIEU',
  NGHE_TRA_LOI_GHI_AM: 'NGHE_TRA_LOI_GHI_AM',
  NGHE_DICH: 'NGHE_DICH',
  LESSON_PART_1: 'LESSON_PART_1',
  LESSON_PART_2: 'LESSON_PART_2',
  DEMO_TEST_PART_1: 'DEMO_TEST_PART_1',
  DEMO_TEST_PART_2: 'DEMO_TEST_PART_2',
  FAST_TRACK: 'FAST_TRACK',
  HOAN_THIEN_CAU: 'HOAN_THIEN_CAU',
  NHAP_VAI: 'NHAP_VAI',
}

export const TRACKING_PAGE = {
  HOME: PATH.HOME,
  ROADMAP_SUMMARY: PATH.ROADMAP_SUMMARY,
  LOGIN: PATH.LOGIN,
  REGISTER: PATH.REGISTER,
  FORGET_PASSWORD: PATH.FORGET_PASSWORD,
  TOPIC: PATH.LEARN,
  TOPIC_DETAIL: PATH.LESSON,
  GYM: PATH.GYM,
  L_GYM_PRONOUNCE: PATH.GYM_PRONOUNCE,
  L_GYM_PAIR: PATH.GYM_PAIR,
  L_GYM_PRACTICE: PATH.GYM_PRACTICE,
  GYM_RESULT: PATH.GYM_RESULT,
  EXAM: PATH.EXAM,
  L_EXAM_ROOM: PATH.EXAM_ROOM,
  EXAM_HISTORY: PATH.EXAM_HISTORY,
  EXAM_FEEDBACK: PATH.EXAM_RESULT,
  NOTEBOOK: PATH.LEARN_NOTEBOOK,
  L_PRACTICE_PHRASE_ZOOM: PATH.LEARN_REVISE_ROOM,
  PRACTICE_PHRASE_OVERVIEW: PATH.LEARN_REVISE,
  PRACTICE_PHRASE_RESULT: PATH.LEARN_REVISE_ROOM_COMPLETE,
  L_PRACTICE_SENTENCE_ZOOM: PATH.LEARN_REVISE_SENTENCE,
  PRACTICE_SENTENCE_OVERVIEW: PATH.LEARN_REVISE_SENTENCE_OVERVIEW,
  PRACTICE_SENTENCE_RESULT: PATH.LEARN_REVISE_SENTENCE_RESULT,
  VOCABULARY: PATH.GYM_VOCABULARY,
  L_VOCABULARY_ZOOM: PATH.LEARN_VOCABULARY,
  VOCABULARY_OVERVIEW: PATH.LEARN_VOCABULARY_OVERVIEW,
  VOCABULARY_RESULT: PATH.LEARN_VOCABULARY_RESULT,
  L_FAST_TRACK_ZOOM: PATH.LEARN_FAST_TRACK,
  L_LEARN_PART_1: PATH.CONVERSATION,
  L_LEARN_PART_2: PATH.LEARN_PART_TWO,
}

export const defaultAvatarUrl = 'https://i.ibb.co/3S9SF5k/avt.png'